import {
  ISpaceTypesState,
  SpaceTypeColor,
} from 'spw-redux/modules/space_types/types';
import { pick } from 'ramda';
import { CLEAN_UP_CURRENT_PROJECT } from '../projects/actions';
import {
  Actions,
  FETCH_PROJECT_SPACE_TYPES,
  FETCH_PROJECT_SPACE_TYPES_SUCCESS,
  SET_CURRENT_SPACE_TYPE_COLORS,
  TOGGLE_CLIENT_FACING_NAMES_ARE_VISIBLE,
} from './actions';

const initialState: ISpaceTypesState = {
  isFetchingSpaceTypes: false,
  clientFacingNamesAreVisible: false,
  spaceTypes: [],
  currentSpaceTypeColors: {},
};

const reducer = (
  state: ISpaceTypesState = initialState,
  action: Actions | { type: typeof CLEAN_UP_CURRENT_PROJECT }
) => {
  switch (action.type) {
    case FETCH_PROJECT_SPACE_TYPES: {
      return { ...state, isFetchingSpaceTypes: true };
    }
    case FETCH_PROJECT_SPACE_TYPES_SUCCESS: {
      const { projectSpaceTypes } = action.payload;

      const currentSpaceTypeColors = projectSpaceTypes
        .map((projectSpaceType) => {
          return pick(
            ['id', 'color', 'gradientColorIndex'],
            projectSpaceType
          ) as SpaceTypeColor;
        })
        .reduce((colors, spaceTypeColor) => {
          return {
            ...colors,
            [spaceTypeColor.id]: spaceTypeColor,
          };
        }, {});

      return {
        ...state,
        isFetchingSpaceTypes: false,
        spaceTypes: projectSpaceTypes,
        currentSpaceTypeColors,
      };
    }
    case SET_CURRENT_SPACE_TYPE_COLORS: {
      return {
        ...state,
        currentSpaceTypeColors: action.payload.currentSpaceTypeColors,
      };
    }
    case TOGGLE_CLIENT_FACING_NAMES_ARE_VISIBLE: {
      return {
        ...state,
        clientFacingNamesAreVisible: !state.clientFacingNamesAreVisible,
      };
    }
    case CLEAN_UP_CURRENT_PROJECT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
